import FormControlLabel from '@material-ui/core/FormControlLabel';

export default FormControlLabel;
